<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <!--table-->
        <div>
          <button type="button" id="btnPopupDT" (click)="showWeightageUserwise()" style="display:none">showWeightageUserwise</button>
          <button type="button" id="BtnPopup" (click)="showWeightageUserwise()" style="display:none">showWeightageUserwise</button>
          <button type="button" id="btnTransferDT" (click)="ShowTransferPopup()" style="display:none">ShowTransferPopup</button>
          <button type="button" id="btnResignedDT" (click)="ShowRejectPopup()" style="display:none">ShowRejectPopup</button>
          <button type="button" id="btnRejectUser" (click)="ResignedUser()" style="display:none">RejectUser</button>
          <button type="button" id="btnTransferUser" (click)="TransferUser()" style="display:none">TransferUser</button>
          <table #dataTable class="display" style="width:100%"></table>
        </div>

        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-lg">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <!--Loader gif-->
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>

              <div class="modal-body" style="overflow-y: hidden; max-height: 630px;">

                <div class="card">
                  <div class="card-body">
                    <div class="form-group">
                      <h5>weightage Performance {{username}} </h5>
                      <br />

                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Role<em>*</em></label>
                            <select id="ddlRoleType" class="form-control">
                              <option *ngFor="let item of RoleList" [value]="item.RoleID">{{ item.RoleName }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label>Non Production</label>
                            <input id="Txt_NonProduction" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_NonProduction')" />
                          </div>
                          
                          <div class="form-group">
                            <label>Productivity Achieved<em>*</em></label>
                            <input id="Txt_ProductivityAchieved" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_ProductivityAchieved')" />
                          </div>
                          <div class="form-group">
                            <label>Occupancy<em>*</em></label>
                            <input id="Txt_Occupancy" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_Occupancy')" />
                          </div>
                          <div class="form-group">
                            <label>Punctuality<em>*</em></label>
                            <input id="Txt_Punctuality" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_Punctuality')" />
                          </div>
                          <div class="form-group">
                            <label>Attendance<em>*</em></label>
                            <input id="Txt_Attendance" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_Attendance')" />
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Daily Target Page<em>*</em></label>
                            <input id="Txt_DailyTargetPage" type="number" class="form-control" />
                          </div>
                          <div class="form-group">
                            <label>Comment</label>
                            <textarea id="Txt_CommentNote" class="form-control" rows="6" style="resize: none;"></textarea>
                          </div>
                        </div>
                      </div>
                      <!--<div class="col-sm-4">
                        <label>LD Training<em>*</em></label>
                        <input id="Txt_LD_Training" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_LD_Training')" />
                      </div>

                      <div class="col-sm-4">
                        <label>APQC Skills<em>*</em></label>
                        <input id="Txt_APQC_Skills" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_APQC_Skills')" />
                      </div>

                      <div class="col-sm-4">
                        <label>Deliver RCA Skills<em>*</em></label>
                        <input id="Txt_DeliverRCA_Skills" type="number" class="form-control" max="100" min="0" oninput="if(this.value > 100) this.value = 100" (change)="calculateTotal('Txt_DeliverRCA_Skills')" />
                      </div>-->
                      <p class="col-sm-12 fw-semibold pt-2">
                        <strong class="text-warning">Note:</strong>Non Production + Productivity Achieved + Occupancy + Punctuality + Attendance must equal <strong>100</strong>.
                      </p>
                      <div class="col-sm-6">
                        <label>Total Sum</label>
                        <input id="Txt_TotalSum" type="number" class="form-control" disabled />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="UpdateWeightageUserwise()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!--Add User deatails-->
      <div id="btnAddPopupartDetails" class="modal" style="position: fixed !important;display:none">
        <div class="modal-dialog modal-lg">
          <div class="modal-content" id="modal_contentArt">
            <div class="modal-header" style="text-align:center">
              <h4 class="modal-title"> {{title}} </h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hideaddUserpopup()">×</button>
            </div>
            <!--Loader gif-->
            <div id="LoadingImagePopup1">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
            </div>

            <div class="modal-body" style="overflow-x:auto !important;">
              <div class="card">
                <div class="card-body">
                  <div class="form-group">
                    <div class="row form-group">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="txtEmpID">Old Emp Id</label>
                          <input type="text" class="form-control" name="EmpID" id="txtOldEmpID" placeholder="Employee ID..." required maxlength="20">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="txtEmpID">New Emp Id <em>*</em></label>
                          <input type="text" class="form-control" name="EmpID" id="txtNewEmpID" (input)="copyEmpIdToLoginId()" placeholder="Employee ID..." required maxlength="20">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="txtFirstName">First Name:</label><em>*</em>
                          <input type="text" class="form-control" name="FirstName" id="txtFirstName" placeholder="First Name..." required maxlength="20">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="txtLastName">Last Name:</label><em>*</em>
                          <input type="text" class="form-control" name="LastName" id="txtLastName" placeholder="Last Name..." required maxlength="20">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="txt_LoginID">User Name:</label><span class="required">*</span>
                          <input type="text" name="LoginID" class="form-control" id="txtLoginID" placeholder="Enter User Name..." disabled required maxlength="50">
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="txtEmail">Email Id:</label><em>*</em>

                          <input type="email" name="EmailID" class="form-control" id="txtEmail" placeholder="Enter User Email..." required
                                 (change)="emailidOnly($event)" maxlength="120">
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label>Role<em>*</em></label>
                          <select id="ddlWeightageRole" class="form-control">
                            <option *ngFor="let item of WeightageRoleLis" [value]="item.RoleID">{{ item.RoleName }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Active Status:</label><em>*</em>
                          <select id="ddlActiveStatus" name="ActiveStatus" class="form-control select2">
                            <option>Active</option>
                            <option>InActive</option>
                          </select>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideaddUserpopup()">Close</button>
                  <button type="submit" (click)="NewUserUpdate()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!--Reject User deatails-->
      <div id="btnRejectPopupartDetails" class="modal" style="position: fixed !important;display:none">
        <div class="modal-dialog modal-lg">
          <div class="modal-content" id="modal_contentArt">
            <div class="modal-header" style="text-align:center">
              <h4 class="modal-title"> Reject User </h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hideRejectUserpopup()">×</button>
            </div>
            <!--Loader gif-->
            <div id="LoadingImagePopup2">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
            </div>
            <div class="modal-body" style="overflow-x:auto !important;">
              <div class="card">
                <div class="card-body">
                  <div class="form-group">
                    <div class="row form-group">
                      <div class="col-sm-6">
                        <label>Reject Date <em>*</em></label>
                        <input type="date" name="RejectDate" class="form-control float-right" id="Txt_RejectDate" autocomplete="off">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideRejectUserpopup()">Close</button>
                  <button type="submit" (click)="RejectConfirmation()" class="btn btn-outline-success waves-effect waves-light">Reject</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Transfer User deatails-->
      <div id="btnTransferPopupartDetails" class="modal" style="position: fixed !important;display:none">
        <div class="modal-dialog modal-lg">
          <div class="modal-content" id="modal_contentArt">
            <div class="modal-header" style="text-align:center">
              <h4 class="modal-title"> Transfer User </h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hideTransferUserpopup()">×</button>
            </div>
            <!--Loader gif-->
            <div id="LoadingImageReopen">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
            </div>
            <div class="modal-body" style="overflow-x:auto !important;">
              <div class="card">
                <div class="card-body">
                  <div class="form-group">
                    <div class="row form-group">
                      <button type="button" id="btnDepartmentsListByBUHead" (click)="DepartmentsListByBUHead()" style="display:none">DepartmentsListByBUHead</button>
                      <div class="col-sm-4">
                        <label>BU Head<em>*</em></label>
                        <select id="ddlBUHead" class="form-control" onchange="$('#btnDepartmentsListByBUHead').trigger('click');">
                          <option *ngFor="let item of BUHeadList" [value]="item.BUHeadID">{{ item.BUHeadLoginName }}</option>
                        </select>
                      </div>
                      <div class="col-sm-4">
                        <label>Department<em>*</em></label>
                        <select id="ddlDepartment" class="form-control">
                          <option *ngFor="let item of DepartmentsList" [value]="item.DepartmentId">{{ item.DepartmentName }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideTransferUserpopup()">Close</button>
                  <button type="submit" (click)="TransferConfirmation()" class="btn btn-outline-success waves-effect waves-light">Transfer</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
